import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import seo_img from '../img/seo/seo-1.svg'
import seo_img_2 from '../img/seo/seo-2.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Seo extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>

				<Helmet
					title="Writing Jobs from Home - UvoCorp.com"
					meta={[
						{ name: "description", content: "Writing jobs from home. Apply for a  job online with UvoCorp.com and start earning immediatly. Registration is free." },

						{ property: 'og:title', content: "Writing Jobs from Home - UvoCorp.com" },
						{ property: 'og:description', content: "Writing jobs from home. Apply for a  job online with UvoCorp.com and start earning immediatly. Registration is free." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/writing_jobs_from_home.html" },
						{ rel: 'alternate', href: "https://www.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en" },
						{ rel: 'alternate', href: "https://canada.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ca" },
						{ rel: 'alternate', href: "https://hongkong.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-hk" },
						{ rel: 'alternate', href: "https://india.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-in" },
						{ rel: 'alternate', href: "https://nigeria.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ng" },
						{ rel: 'alternate', href: "https://pakistan.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-pk" },
						{ rel: 'alternate', href: "https://philippines.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ph" },
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">
				
					<div className="inner-header">
						<div className="container">
							<h1>Writing Jobs from Home</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="home-benefits home-block hiring-benefits">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<Link to="/prices.html">View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></Link>
						</div>
					</div>

					<div className="inner-white hiring seo">
						<div className="container">
							<h2>Writers wanted</h2>
							<div className="row">
								<div className="col-md-9">
									<p>Dear potential <Link to="/">UVOCORP</Link> writers, we are currently hiring:</p>
									<ol className="hiring-steps">
										<li>Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);</li>
										<li>English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;</li>
										<li>Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:</li>
									</ol>
								
									<ul className="hiring-disciplines">
										<li className="discipline_8">Accounting</li>
										<li className="discipline_15">Architecture, Building and Planning</li>
										<li className="discipline_14">Biology (and other Life Sciences)</li>
										<li className="discipline_13">Chemistry</li>
										<li className="discipline_1">Engneering</li>
										<li className="discipline_10">Civil Engineering</li>
										<li className="discipline_7">Computer Science</li>
										<li className="discipline_5">IT, Web</li>
										<li className="discipline_3">Finance</li>
										<li className="discipline_11">Mathematics</li>
										<li className="discipline_12">Physics</li>
										<li className="discipline_4">Statistics</li>
									</ul>
								</div>
								<div className="hiring-img">
									<img src={seo_img_2} alt="Seo Image"/>
								</div>
							</div>

							<div className="row seo-row">

								<div className="col-md-4 seo-img-container">
									<div className="seo-img">
										<img src={seo_img} alt="Seo Image"/>
									</div>
								</div>
								<div className="col-md-8">

									<p>Writing jobs from home are not as easy to find as most would lead us to believe. There are many pitfalls when seeking work-from-home positions from which a writer can make money. Most positions are not writing jobs from home, they are often positions where you pay to be placed into a database, to be selected by hundreds of clients you cannot view or contact. Other "get paid to write" positions might involve a few scant dollars for several pages of writing, and when writing for money, you need a job that maximizes pay and time used. Our freelance writer vacancy is all about providing writing jobs from home to skilled writers with degrees. Our goal is to match talented and experienced writers to clients seeking those skills, and we do that through our application process, not a paid website.</p>
									<p>When you need a work-from-home position that supports your financial needs, you need writing jobs from home that meet your family demands, your schedules, and your pay requirements. You need a position where the pay is reliable but the hours are flexible. You need a position that puts your special circumstances first. Our organization is committed to matching writers to their subjects, to their skill sets, and to the flexible hours they need. You select your projects, you read their instructions, and you decide which projects best fit your schedule and skill sets. You can find the best writing jobs from home when you work for us, where we always put you in a position to reach paying clients and complete successful written projects. Writing jobs from home are available to pay you what you want to be paid, and here at <Link to="/">UVOCorp</Link> you can apply free. Our freelance writer vacancy demands writers with degrees, who seek writing jobs from home.</p>

								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/writing_jobs_from_home.html.js